module.exports = __webpack_public_path__ + "PF.png?856b1129faed293b7f53dcac26c46f6d";